export const invoiceStatusLimitedLabelsMapping = {
    srNumber: "Sr. No.",
    invoice_no: "Invoice Number",
    net_amount: "Net Amount",
    gst_amount: "GST Amount",
    utrStatus: "Payment Status"
}

export const invoiceStatusLabelsMapping = {
    "srNumber": "Sr. No.",
    "invoice_no": "Invoice Number",
    "net_amount": "Net Amount",
    "gst_amount": "GST Amount",
    "utrStatus": "Payment Status",
    "Payee Name": "Payee Name",
    "NT_Cheque Date": "Payment Date",
    "Bank Name": "Payee Bank Name",
    "NT_Cheque No": "UTR NO",
    "Payment Mode": "Payment Mode",
    "Bank Branch Name": "Payee Bank Branch Name",
    "Invoice No": "HEGIC Invoice Number",
    "chase_invoice_no":"Chase Invoice No",
    "vendor_invoice_no": "Vendor Invoice No",
    // "gross_amount": "Gross Amount",
    "net_payable": "Net Payable",
    "gst_number" : "GST Number",
    "cgst" : "CGST",
    "sgst" : "SGST",
    "ugst" : "UTGST",
    "igst" : "IGST",
    "gross_amount": "Invoice Amount",
    // "charge_total" : "Charge Total",
    // "tds_per" :"TDS Per",
    // "tds_value" : "TDS Value",
    // "total_amount" : "Total Amount"
};

export const invoiceStatusLabelsSortingOrder = [
    "srNumber",
    "invoice_no",
    "utrStatus",
    "Payee Name",
    "NT_Cheque Date",
    "Bank Name",
    "NT_Cheque No",
    "Payment Mode",
    "Bank Branch Name",
    "chase_invoice_no",
    "vendor_invoice_no",
    "Invoice No",
    "net_amount",
    "gst_amount",
    "gross_amount",
    "net_payable",
];

export const truncateText = (text, maxLength = 20) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};